import { NgModule } from "@angular/core";
import { InputGridFormComponent } from './input-grid-form/input-grid-form.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { IonicModule } from '@ionic/angular';
import { CommonModule } from '@angular/common';
import { DynamicInputGridComponent } from './dynamic-input-grid.component';
import { InputGridDesignComponent } from './input-grid-design/input-grid-design.component';
import { DynamicFormsIonicUIModule } from '@ng-dynamic-forms/ui-ionic';
import { InputGridColumnsBuilderComponent } from './input-grid-columns-builder/input-grid-columns-builder.component';
import { DynamicInputGridColumnsBuilderComponent } from './input-grid-columns-builder/dynamic-input-grid-columns-builder.component';
import { InputGridColumnsBuilderDialogComponent } from './input-grid-columns-builder-dialog/input-grid-columns-builder-dialog.component';
import { MatDialogModule } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import {MatFormFieldModule} from '@angular/material/form-field';
import {MatInputModule} from '@angular/material/input';
import {MatSelectModule} from '@angular/material/select';
import { DatasourcePickerModule } from '../datasource-picker/datasource-picker.module';
import { RichAutocompleteModule } from '../rich-autocomplete/rich-autocomplete.module';
import { InputGridResultComponent } from './input-grid-result/input-grid-result.component';
import { InputGridColumnsDatasourceMappingComponent } from './input-grid-columns-datasource-mapping/input-grid-columns-datasource-mapping.component';
import { DynamicInputGridColumnsDatasourceMappingComponent } from './input-grid-columns-datasource-mapping/dynamic-input-grid-columns-datasource-mapping.component';
import { InputGridColumnsDatasourceMappingDialogComponent } from './input-grid-columns-datasource-mapping-dialog/input-grid-columns-datasource-mapping-dialog.component';
import { MatTableModule } from '@angular/material/table';
import { DatasourceDatasSelectionModule } from '../datasource-datas-selection/datasource-datas-selection.module';
import { MatRadioModule } from '@angular/material/radio';

@NgModule({
    declarations: [
        DynamicInputGridComponent, InputGridFormComponent, InputGridDesignComponent, InputGridColumnsBuilderComponent, 
        DynamicInputGridColumnsBuilderComponent, InputGridColumnsBuilderDialogComponent, InputGridResultComponent,
        DynamicInputGridColumnsDatasourceMappingComponent, InputGridColumnsDatasourceMappingDialogComponent, InputGridColumnsDatasourceMappingComponent
    ],
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        IonicModule,
        DynamicFormsIonicUIModule,
        MatDialogModule,
        MatButtonModule,
        MatFormFieldModule,
        MatInputModule,
        MatSelectModule,
        MatTableModule,
        MatFormFieldModule,
        MatRadioModule,
        DatasourcePickerModule,
        RichAutocompleteModule,
        DatasourceDatasSelectionModule
    ],
    entryComponents: [
        DynamicInputGridComponent,
        InputGridColumnsBuilderDialogComponent,
        DynamicInputGridColumnsBuilderComponent,
        DynamicInputGridColumnsDatasourceMappingComponent,
        InputGridColumnsDatasourceMappingDialogComponent
    ]
})
export class InputGridModule {}